import styled from "styled-components";

const ErrorDescription = styled.div`
    &:not(:last-child) {
        margin-bottom: 8px;
    }
`

export default ErrorDescription;
